<template>
  <section class="tabs_win_history">
    <TransparentCard>
      <h1 class="pg_title">{{ $_translations.value.page_get_started_section_winners_title }}</h1>

      <h2 class="subtitle">{{ $_translations.value.page_get_started_section_winners_subtitle }}</h2>

      <BaseTabs
        :tabs="tabs"
        :active-tab="activeTab"
        @tab:click="setActiveTab"
      />

      <WinnersHistoryList
        v-for="(winners, type) in winnersPerTab"
        :key="type"
        :is-active="activeTab === type"
        :winners-history="winners"
      />
    </TransparentCard>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import TransparentCard from '@/components/card/TransparentCard.vue';
import BaseTabs from '@/components/tabs/BaseTabs.vue';
import WinnersHistoryList from '@/views/getStarted/components/WinnersHistoryList.vue';
import useTab from '@/hooks/useTab.js';
import { prizeTypeEnum } from '@/constants/winners.js';

const tabs = [
  { value: prizeTypeEnum.GRAND, sortOrder: 3 },
  { value: prizeTypeEnum.MONTHLY, sortOrder: 2 },
  { value: prizeTypeEnum.WEEKLY, sortOrder: 1 },
].toSorted((a, b) => a.sortOrder - b.sortOrder)
  .map(({ sortOrder: _sortOrder, ...rest }) => ({
    ...rest,
    text: `page_get_started_section_winners_tab_${ rest.value }`,
  }));

const props = defineProps({
  winnerList: {
    type: Array,
    default: () => [],
  },
});

const [activeTab, setActiveTab] = useTab(prizeTypeEnum.WEEKLY);

const winnersPerTab = computed(() => {
  return props.winnerList.reduce((acc, { prizeDTO, userDTO, localDateTime }) => {
    acc[prizeDTO.type].userList.push({
      msisdn: userDTO?.msisdn,
      username: userDTO?.username,
      avatar: userDTO?.avatar,
      rewardDescription: prizeDTO?.headline,
      rewardDate: localDateTime,
    });

    return acc;
  }, {
    [prizeTypeEnum.GRAND]: { type: prizeTypeEnum.GRAND, userList: [] },
    [prizeTypeEnum.MONTHLY]: { type: prizeTypeEnum.MONTHLY, userList: [] },
    [prizeTypeEnum.WEEKLY]: { type: prizeTypeEnum.WEEKLY, userList: [] },
  });
});
</script>
